import type { ScopedEnablements } from '@portal/pkg-authorization'

/**
 * A type the grid and the entity-details nav may show. Enabled is not enough:
 * View Entity (`Entity.READ`) within that type's scope is what grants access,
 * including for a subentity. The entity-type catalog is wider than this — other
 * grants still reveal a type so create and similar actions can offer it.
 */
export function isViewableEntityType(
  entityType: { id: number; enabled?: boolean } | null | undefined,
  scopedEnablements: ScopedEnablements,
): boolean {
  if (entityType?.enabled !== true) {
    return false
  }
  return scopedEnablements
    .for({ entityTypeId: entityType.id })
    .hasStandardEnablement('Entity', 'READ')
}

/**
 * Whether a subentity link or a direct subentity URL is allowed. Successors
 * nested on a parent type may be stale, so the decision uses the catalog entry
 * with the same id.
 */
export function isViewableSuccessor(
  subEntityCode: string,
  successors: ReadonlyArray<{ id: number; code: string }> | undefined,
  catalog: ReadonlyArray<{ id: number; enabled?: boolean }> | undefined,
  scopedEnablements: ScopedEnablements,
): boolean {
  const successor = successors?.find((candidate) => candidate.code === subEntityCode)
  if (!successor) {
    return false
  }
  return isViewableEntityType(
    catalog?.find((entityType) => entityType.id === successor.id),
    scopedEnablements,
  )
}
